import { setDebug } from './DEBUG';
import { Shortcuts, ComponentFocusManager } from './shortcuts';
import { Hotkeys, announceHotkeys } from './hotkeys';
import announce from './announce';

// const hotkeys = new Hotkeys();
// const shortcuts = new Shortcuts();


export default {
  Shortcuts,
  ComponentFocusManager,
  Hotkeys,
  announceHotkeys,
  announce,
  setDebug,

  // hotkeys,
  // shortcuts,
};
